import firebase from 'firebase'
import {NotificationManager} from "react-notifications";


export const initializePush = () => {

    if (firebase.messaging.isSupported()) {
        const messaging = firebase.messaging();

        messaging.requestPermission()
            .then(() => {
                return messaging.getToken();
            })
            .then(token => {
                localStorage.setItem('fcm-token', JSON.stringify(token))
                //you probably want to send your new found FCM token to the
                //application server so that they can send any push
                //notification to you.
            })
            .catch(error => {
                if (error.code === "messaging/permission-blocked") {
                    console.log("Please Unblock Notification Request Manually");
                } else {
                    console.log("Error Occurred", error);
                }
            });
        messaging.onMessage(payload => {

            // console.log(payload.notification)
            NotificationManager.info(payload.notification.body, payload.notification.title, 10000);

            // alert(payload.notification.title, payload.notification.body);
            //this is the function that gets triggered when you receive a
            //push notification while you’re on the page. So you can
            //create a corresponding UI for you to have the push
            //notification handled.
        });
    }
};






// WEBPACK FOOTER //
// ./src/initialize.js